import { TiktokMetadata } from '@monorepo/types';
import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const TiktokAgreement = ({ metadata }: { metadata: TiktokMetadata }) => {
  const { t } = useTranslation();
  const links = {
    music:
      'https://www.tiktok.com/legal/page/global/music-usage-confirmation/en',
    branded: 'https://www.tiktok.com/legal/page/global/bc-policy/en',
  };

  const MusicLink = () => (
    <a href={links.music} target="_blank" rel="noopener noreferrer">
      Music Usage Confirmation
    </a>
  );

  const BrandedLink = () => (
    <a href={links.branded} target="_blank" rel="noopener noreferrer">
      Branded Content Policy
    </a>
  );

  const getDeclarationText = () => {
    if (metadata?.brandOptions?.brandedContent) {
      return (
        <>
          {t('videoEditor.socialPublish.tiktok.agreementBranded')}{' '}
          <BrandedLink /> {t('videoEditor.socialPublish.tiktok.agreementAnd')}{' '}
          <MusicLink />.
        </>
      );
    }
    return (
      <>
        {t('videoEditor.socialPublish.tiktok.agreementMusic')} <MusicLink />.
      </>
    );
  };

  return (
    <div>
      <Text type="secondary">{getDeclarationText()}</Text>
    </div>
  );
};

export default TiktokAgreement;
